<template>
<div>
  <div v-if="flow==1">
    <canvas ref="admins" width="1280" height="863"></canvas>
    <div style="color: red;">(温馨提示：<a style="color: blue" href="javascript:;" @click="downImg()">点击下载通知书</a>
      以下是入学须知与十四天体温检测表，请下载并认真填写
      <a style="color: blue" :href="require('../assets/images/xz.jpg')" download="入学须知">点击下载入学须知</a>
      <a style="color: blue" :href="require('../assets/images/14.jpg')" download="十四天体温检测表">点击下载十四天体温检测表</a>
      )</div>
    <img src="../assets/images/xz.jpg" />
    <img src="../assets/images/14.jpg" />
  </div>
</div>
</template>

<script>
export default {
  name: "admission",
  data(){
    return {
      flow:0,
      id_card:'',
      info:{
        name:'名字',
        department:'系',
        major:'专业',
        admission_deadline_year:'2011',
        admission_deadline_month:'09',
        admission_deadline_day:'01',
        admission_generation_year:'2011',
        admission_generation_month:'06',
        admission_generation_day:'28',
        admission_id:'isnd001',
        level:0,
      },
    }
  },
  created() {
    this.id_card = this.$route.query.id_card;
    this.getCardInfo();
  },
  methods:{
    downImg(){
      var myCanvas = this.$refs.admins
      let pageData = myCanvas.toDataURL('image/jpeg', 1.0)
      var oA = document.createElement("a");
      oA.download = '录取通知书';// 设置下载的文件名，默认是'下载'
      oA.href = pageData;
      document.body.appendChild(oA);
      oA.click();
      oA.remove(); // 下载之后把创建的元素删除
    },
    getCardInfo(){
      var getParam = {}
      getParam['id_card'] = this.id_card
      this.$request.get('enroll-detail',getParam,(response)=>{
        if(response.data.code == 200){
          if(response.data.data.enroll_status == this.$const.ENROLL_STATUS_1 && response.data.data.finance_check==1){
            //已录取已支付已通过
            this.flow = 1;
          }
          for(var ind in this.info){
            this.info[ind] = response.data.data[ind];
          }
          this.$nextTick(()=>{
            var myCanvas = this.$refs.admins
            var ctx = myCanvas.getContext('2d');
            var image = new Image();
            image.src = require('@/assets/images/adminssion.png')
            image.onload = () => {
              ctx.drawImage(
                image, //规定要使用的图像、画布或视频。
                0, 0,//在画布上放置图像的 x 、y坐标位置。
                image.width,image.height,
                0,0,
                1280,863,
              );
              // 设置线条的颜色
              // ctx.strokeStyle = '#000';
              // 设置线条的宽度
              // ctx.lineWidth = 3;
              // 绘制直线
              // ctx.beginPath();
              // if(this.info.level == 2){
              //   //高中中
              //   // 起点
              //   ctx.moveTo(226, 435);
              //   // 终点
              //   ctx.lineTo(326, 435);
              // }
              // if(this.info.level == 1){
              //   //高中中
              //   // 起点
              //   ctx.moveTo(226, 435);
              //   // 终点
              //   ctx.lineTo(326, 435);
              // }

              // ctx.closePath();
              // ctx.stroke();

              ctx.font="20px KaiTi blod";
              var dimension = ctx.measureText(this.info.admission_id); // 测量文字
              ctx.fillText(this.info.admission_id,768,86);
              ctx.font="30px KaiTi";
              var dimension = ctx.measureText(this.info.name); // 测量文字
              ctx.fillText(this.info.name,177-(dimension.width / 2),332);
              var dimension = ctx.measureText(this.info.department); // 测量文字
              ctx.fillText(this.info.department,432-(dimension.width / 2),388);
              var dimension = ctx.measureText(this.info.major); // 测量文字
              ctx.fillText(this.info.major,678-(dimension.width / 2),388);
              var dimension = ctx.measureText(this.info.admission_deadline_year); // 测量文字
              ctx.fillText(this.info.admission_deadline_year,589-(dimension.width / 2),444);
              var dimension = ctx.measureText(this.info.admission_deadline_month); // 测量文字
              ctx.fillText(this.info.admission_deadline_month,680-(dimension.width / 2),444);
              var dimension = ctx.measureText(this.info.admission_deadline_day); // 测量文字
              ctx.fillText(this.info.admission_deadline_day,750-(dimension.width / 2),444);
              if(this.info.level == 2){//高中
                ctx.font="30px KaiTi";
                var dimension = ctx.measureText('✔'); // 测量文字
                ctx.fillText('✔',426-(dimension.width / 2),446);
              }
              if(this.info.level == 1){
                ctx.font="30px KaiTi";
                var dimension = ctx.measureText('✔'); // 测量文字
                ctx.fillText('✔',280-(dimension.width / 2),446);
              }

              ctx.font="30px KaiTi";
              var dimension = ctx.measureText(this.info.admission_generation_year); // 测量文字
              ctx.fillText(this.info.admission_generation_year,680-(dimension.width / 2),724);
              var dimension = ctx.measureText(this.info.admission_generation_month); // 测量文字
              ctx.fillText(this.info.admission_generation_month,755-(dimension.width / 2),724);
              var dimension = ctx.measureText(this.info.admission_generation_day); // 测量文字
              ctx.fillText(this.info.admission_generation_day,807-(dimension.width / 2),724);
              ctx.font="25px KaiTi";
              var dimension = ctx.measureText(this.info.name); // 测量文字
              ctx.fillText(this.info.name,1077-(dimension.width / 2),390);
              var dimension = ctx.measureText(this.info.admission_generation_year); // 测量文字
              ctx.fillText(this.info.admission_generation_year,1062-(dimension.width / 2),706);
              var dimension = ctx.measureText(this.info.admission_generation_month); // 测量文字
              ctx.fillText(this.info.admission_generation_month,1121-(dimension.width / 2),706);
              var dimension = ctx.measureText(this.info.admission_generation_day); // 测量文字
              ctx.fillText(this.info.admission_generation_day,1162-(dimension.width / 2),706);

              var newImage = new Image();
              newImage.src = require('@/assets/images/z.png')
              newImage.style.opacity = 0.3;
              newImage.onload = () => {
                ctx.drawImage(
                  newImage, //规定要使用的图像、画布或视频。
                  0, 0,//在画布上放置图像的 x 、y坐标位置。
                  newImage.width,newImage.height,
                  680,540,
                  180,180,
                );
                ctx.drawImage(
                  newImage, //规定要使用的图像、画布或视频。
                  0, 0,//在画布上放置图像的 x 、y坐标位置。
                  newImage.width,newImage.height,
                  1025,540,
                  180,180,
                );
              }
              var newImage2 = new Image();
              newImage2.src = require('@/assets/images/z2.png')
              newImage2.style.opacity = 0.3;
              newImage2.onload = () => {
                ctx.drawImage(
                  newImage2, //规定要使用的图像、画布或视频。
                  0, 0,//在画布上放置图像的 x 、y坐标位置。
                  newImage2.width,newImage2.height,
                  860,440,
                  180,180,
                );
              }
              // var newImage1 = new Image();
              // newImage1.src = require('@/assets/images/g.png')
              // newImage1.onload = () => {
              //   ctx.drawImage(
              //     newImage1, //规定要使用的图像、画布或视频。
              //     0, 0,//在画布上放置图像的 x 、y坐标位置。
              //     newImage1.width,newImage1.height,
              //     270,415,
              //     40,40,
              //   );
              // }

            }
          })
        }else{
          alert(response.data.data);
        }
      })
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admission.vue